export var BUTTON_BS_STYLES = ['default', 'primary', 'success', 'warning', 'danger', 'info', 'link'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Button/ButtonConstants.js
// module id = 148
// module chunks = 0